import request from "@/utils/request";

export const urls = {
  GetRedirectUrlForLoginAdmin: "/api/LoginAdmin/GetRedirectUrlForLoginAdmin", //微信登录，获取Code的请求地址 Json提交
  VerifyOpenIdForLoginAdmin: "/api/LoginAdmin/VerifyOpenIdForLoginAdmin", //微信登录，获取用户信息
  GetQRCode: "/api/LoginAdmin/GetQRCode", //获取登录二维码
  LongPolingLogin: "/api/LoginAdmin/LongPolingLogin", //LongPoling，返回true时表示验证通过
  GetCompanyUser: "/api/LoginAdmin/GetCompanyUser", //获取门店下的用户，传入门店Id
  UpdateLoginAdmin: "/api/LoginAdmin/UpdateLoginAdmin", //更新登录管理员
  DeleteLoginAdmin: "/api/LoginAdmin/DeleteLoginAdmin", //删除登录管理员，传入用户Id
  GetLoginAdmin: "/api/LoginAdmin/GetLoginAdmin", //查看登录管理员
  AddLoginAdminLog: "/api/LoginAdmin/AddLoginAdminLog", //记录免授权登录日志
  QueryLoginAdminLog: "/api/LoginAdmin/QueryLoginAdminLog", //查看管理员授权日志
};

function sendRequest(apiUrl, params, type, option) {
  return request({
    url: apiUrl,
    method: type,
    data: params,
    option,
  });
}
const apis = {};
for (const key in urls) {
  const url = urls[key];
  apis[key] = (params, option = {}) => {
    return sendRequest(url, params, "post", option);
  };
}
export default apis;
